import React, { FC } from "react";
import { InputLabel as MuiInputLabel, type InputLabelProps } from "@mui/material";

const InputLabel: FC<InputLabelProps> = ({ ...props }) => (
  <MuiInputLabel {...props} />
);

export default InputLabel;
